import {Component, OnInit} from 'angular2/core';
import {Router} from "angular2/router";

@Component({
    template: '<div></div>'
})
export class HomeComponent implements OnInit {

    constructor(private _router:Router) {
    }

    errorMessage:string;

    ngOnInit() {
        this._router.navigate(['Campaigns']);
    }
}